// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SQX3x","col":"styles_col__1RLPo"};